import fgidigitalsolutionsTrans from '../assets/images/fgi+digitalsolutions_trans@3x.png';
/* eslint-disable import/prefer-default-export */

export const getCompanyLogo = (company) =>
  company?.logo_url || fgidigitalsolutionsTrans;
